var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('base-popup',{attrs:{"title":'Видео инструкция. ' + _vm.data.Name,"value":_vm.value,"icon":'medexpert-play',"hide-save":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},[(_vm.value)?_c('MaterialYoutube',{staticClass:"mt-6",attrs:{"url":_vm.data.Url}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }